import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import InputText from '../InputText'
import { EyeIcon, EyeOffIcon } from '@heroicons/react/outline'

const InputPassword = props => {
    const {
        label,
        name,
        error,
        variant,
        isRequired,
        helperText,
        ...otherProps
    } = props
    const [revealPassword, setRevealPassword] = useState(false)
    const iconClass = 'w-6 h-6 text-black30 stroke-current transition-opacity'

    const handleToggleRevealButton = () => {
        setRevealPassword(!revealPassword)
    }

    const renderIcon = () => {
        return revealPassword ? (
            <EyeOffIcon
                onClick={handleToggleRevealButton}
                className={iconClass}
            />
        ) : (
            <EyeIcon onClick={handleToggleRevealButton} className={iconClass} />
        )
    }

    return (
        <div className="flex flex-col items-start justify-start w-full h-auto">
            {label && (
                <div className="w-full h-auto flex items-center justify-between mb-2">
                    <label
                        htmlFor={name}
                        className={clsx(
                            'w-full h-auto text-sm font-medium text-left',
                            variant === 'black'
                                ? 'text-white'
                                : 'text-textDarkerGray',
                        )}
                    >
                        {label}
                        {isRequired && (
                            <span className="text-error ml-1">*</span>
                        )}
                    </label>

                    {helperText && helperText}
                </div>
            )}
            <div
                className={clsx(
                    'w-full flex flex-row h-12 items-start justify-center',
                )}
            >
                <InputText
                    type={revealPassword ? 'text' : 'password'}
                    key={null}
                    name={name}
                    hasError={false}
                    variant={variant}
                    additionalInputClass="rounded-tr-none rounded-br-none outline-none border-r-0"
                    label={null}
                    {...otherProps}
                />
                <div
                    className={clsx(
                        'px-4 h-12 cursor-pointer rounded-tr-xl rounded-br-xl border-t border-r border-b flex items-center justify-center',
                        variant === 'black'
                            ? 'bg-black70 border-black60 '
                            : 'bg-white border-grayLines',
                    )}
                >
                    {renderIcon()}
                </div>
            </div>
            <p
                className={clsx(
                    error ? 'visible' : 'invisible',
                    'w-full h-4 text-right text-error font-medium text-xs mt-1',
                )}
            >
                {error}
            </p>
        </div>
    )
}

InputPassword.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    error: PropTypes.string,
    variant: PropTypes.string,
    isRequired: PropTypes.bool,
    helperText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.node,
        PropTypes.element,
    ]),
}

export default InputPassword
